<template>
  <div data-cy="form-spouse">
    <div class="h2">
      Votre conjoint
    </div>

    <!-- Civilité -->
    <input-radio
      label="Civilite"
      slug="civiliteConjoint"
      :model="civiliteConjoint"
      :options="[{'label': 'Mme', 'value': 'mme'}, {'label': 'Mr', 'value': 'm'}]"
      :v$="v$"
      @input="$emit('update:civiliteConjoint', $event.target.value)"
    />

    <!-- Nom -->
    <input-text
      label="Nom"
      slug="nomConjoint"
      :model="nomConjoint"
      :v$="v$"
      @input="$emit('update:nomConjoint', $event.target.value)"
    />

    <!-- Prénom -->
    <input-text
      label="Prénom"
      slug="prenomConjoint"
      :model="prenomConjoint"
      :v$="v$"
      @input="$emit('update:prenomConjoint', $event.target.value)"
    />

    <!-- Date de naissance -->
    <input-text-date
      label="Date de naissance"
      slug="dateDeNaissanceConjoint"
      :model="dateDeNaissanceConjoint"
      :v$="v$"
      @input="$emit('update:dateDeNaissanceConjoint', $event.target.value)"
    />

    <!-- Ayant droit -->
    <input-radio
      label="Votre conjoint est-il votre ayant droit ?"
      slug="ayantDroit"
      :model="ayantDroit"
      :options="[{'label': 'Oui', 'value': '1'}, {'label': 'Non', 'value': '2'}]"
      :v$="v$"
      @input="$emit('update:ayantDroit', $event.target.value)"
    />

    <!-- Régime / Activité / Profession -->
    <regime-select-form
      v-if="ayantDroit === '2'"
      :regimes="regimes"
      :regime="regimeConjoint"
      :activite="activiteConjoint"
      :profession="professionConjoint"
      :madelin="madelinConjoint"
      :display-madelin="displayMadelinConjoint"
      :server-errors="serverErrors"
      regime-slug="regimeConjoint"
      activite-slug="activiteConjoint"
      profession-slug="professionConjoint"
      madelin-slug="madelinConjoint"
      @update-regime="$emit('update:regimeConjoint', $event)"
      @update-activite="$emit('update:activiteConjoint', $event)"
      @update-profession="$emit('update:professionConjoint', $event)"
      @update-madelin="$emit('update:madelinConjoint', $event)"
    />
  </div>
</template>

<script>

import InputRadio from "src/modules/shared/components/Form/InputRadio";
import InputText from "src/modules/shared/components/Form/InputText";
import InputTextDate from "src/modules/shared/components/Form/InputTextDate";
import {computed} from "vue";
import {required, serverError} from "src/modules/shared/validators/validators";
import useVuelidate from "@vuelidate/core";
import RegimeSelectForm from "src/modules/shared/components/Form/RegimeSelectForm";
import dayjs from "dayjs";

export default {
  name: "SpouseInformationForm",
  components: {
    InputRadio,
    InputText,
    InputTextDate,
    RegimeSelectForm
  },
  props: {
    regimes: {
      type: Object,
      default: () => {}
    },
    serverErrors: {
      type: Array,
      required: true
    },
    civiliteConjoint: {
      type: String,
      default: ''
    },
    nomConjoint: {
      type: String,
      default: ''
    },
    prenomConjoint: {
      type: String,
      default: ''
    },
    dateDeNaissanceConjoint: {
      type: String,
      default: ''
    },
    ayantDroit: {
      type: String,
      default: ''
    },
    regimeConjoint: {
      type: String,
      default: ''
    },
    activiteConjoint:{
      type: String,
      default: ''
    },
    professionConjoint: {
      type: String,
      default: ''
    },
    madelinConjoint: {
      type: String,
      default: ''
    },
    displayMadelinConjoint: {
      type: String,
      default: ''
    },
  },
  emits: [
    'update:civiliteConjoint',
    'update:nomConjoint',
    'update:prenomConjoint',
    'update:dateDeNaissanceConjoint',
    'update:ayantDroit',
    'update:regimeConjoint',
    'update:activiteConjoint',
    'update:activiteConjoint',
    'update:professionConjoint',
    'update:madelinConjoint'
  ],
  setup (props) {
    const validations = computed(() => ({
      civiliteConjoint: {
        required,
        serverError: serverError(props, 'civiliteConjoint')
      },
      nomConjoint: {
        required,
        serverError: serverError(props, 'nomConjoint')
      },
      prenomConjoint: {
        required,
        serverError: serverError(props, 'prenomConjoint')
      },
      dateDeNaissanceConjoint: {
        required,
        serverError: serverError(props, 'dateDeNaissanceConjoint')
      },
      ayantDroit: {
        required,
        serverError: serverError(props, 'ayantDroit')
      },
    }))

    const birthdayToDate = dayjs().subtract(18, 'years').format('DD/MM/YYYY')
    const birthdayFromDate = dayjs().subtract(100, 'years').format('DD/MM/YYYY')

    const v$ = useVuelidate(validations, props)

    return { v$, birthdayToDate, birthdayFromDate }
  },
  watch: {
    serverErrors () {
      this.v$.$reset()
      this.v$.$touch()
    }
  }
}
</script>

<style scoped>

</style>
